import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(unauth)/news/components/comments/Comments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CopyToClipboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/news/RelatedPost.tsx");
